export default {
  routes: [
    {
      name: 'personalCards',
      path: '/directory/personal_card',
      component: () => import('./views/ThePersonalCards.vue'),

    },

    {
      name: 'personalCard',
      path: '/directory/personal_card/:uuid',
      component: () => import('./views/ThePersonalCard.vue'),
    },
  ]
}
